import Backbone from 'backbone';

import {AaSequenceAlignmentRow} from 'constants/AlignmentConstants';
import AaSequenceAlignmentRowView from 'molbio/maps/alignment/AaSequenceAlignmentRowView';
import {MinimalAlignmentRowsView} from 'molbio/maps/alignment/PolymerAlignmentRowsView';
import ProteinAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';

export default class AaSequenceAlignmentRowsView
  extends Backbone.View<ProteinAlignmentTabState>
  implements MinimalAlignmentRowsView
{
  rowViews!: Array<AaSequenceAlignmentRowView>;
  rowsContainer!: HTMLDivElement;

  static initClass(): void {
    this.prototype.className = 'scrolling-alignment-rows';
  }

  update(): void {
    if (this.rowViews) {
      this.rowViews.forEach((rowView) => {
        rowView.remove();
      });
    }
    this.rowViews = this.model
      .get('alignment')!
      .rows.map((row: AaSequenceAlignmentRow, i: number) => ({row, i}))
      .filter(({i}: {i: number}) => i !== 0)
      .map(
        ({row, i}: {row: AaSequenceAlignmentRow; i: number}): AaSequenceAlignmentRowView =>
          new AaSequenceAlignmentRowView({
            model: this.model,
            tabstate: this.model,
            row,
            visibilityOptions: this.model.get('localVisibilityOptionsList')![i],
          })
      );
    this.rowViews.forEach((rowView) => {
      this.rowsContainer.appendChild(rowView.render().el);
    });
  }

  resizeSVGs(): void {
    this.rowViews.forEach((view) => {
      view.setSVGWidth();
    });
  }

  showRange(left: null | number = null): void {
    this.rowViews.forEach((view) => {
      view.showRange(left);
    });
  }

  override render(): this {
    this.rowsContainer = document.createElement('div');
    this.el.appendChild(this.rowsContainer);
    this.update();
    return this;
  }

  die(): void {
    this.rowViews.forEach((rowView) => {
      rowView.die();
    });
  }

  override remove(): this {
    this.die();
    super.remove();
    return this;
  }
}

AaSequenceAlignmentRowsView.initClass();
